<div id="content" class="allcp-form" ng-controller="CustomerAccountController" ng-init="init()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <header class="navbar navbar-fixed-top subnavbar bg-system">
        <ul class="nav navbar-nav nav-tabs navbar-left">
            <li>
                <a class="btn btn-operation ml10" href="customer-settings" data-toggle="tab">Company Info</a>
            </li>
            <li>
                <a class="btn btn-operation ml10" href="customer-settings" data-toggle="tab">Change Password</a>
            </li>
            <li class="active">
                <a class="btn btn-operation ml10" href="customer-integrations">Integrations</a>
            </li>
            <li>
                <a class="btn btn-operation ml10" href="customer-settings" data-toggle="tab">My Cards</a>
            </li>
        </ul>
    </header>
    <div class="panel-body">
        <div class="row">
            <div class="col-md-12">
                <div class="tab-content">
                    <div class="tab-pane active" id="integrations">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Uber</h3>
                                    <a 
                                        href="{{uberOAuthUrl}}" 
                                        class="btn btn-hod">
                                        Connect With Uber
                                    </a>
                                    <ul class="list-group mt-3">
                                        <li class="list-group-item" ng-repeat="item in uberStores" style="display: flex; align-items: center; justify-content: space-between;">
                                            <div class="d-flex align-items-start flex-column">
                                                <span class="mb-2">{{ item.store_name }}</span>
                                                <span class="mb-2">Store ID : {{ item.store_id }}</span>
                                                <small class="mb-2"><a href="{{ item.web_url }}" target="__BLANK">{{ item.web_url }}</a></small>
                                            </div>
                                            <div class="d-flex align-items-end flex-column">
                                                <a href="/uber-menu/{{item.store_id}}" class="mt-2 text-success">Manage Menu</a>
                                                <a href="#" ng-click="updateStoreAutoAccept(item.store_id, true)" ng-if="!item.auto_accept_order" class="mt-2 text-success">Enable Order Confirmed</a>
                                                <a href="#" ng-click="updateStoreAutoAccept(item.store_id, false)" ng-if="item.auto_accept_order" class="mt-2 text-danger">Disable Order Confirmed</a>
                                                <a href="#" ng-click="removeUberConnect(item.store_id)" class="mt-2 text-danger">Remove Connect</a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-12">
                                    <h3>Grubhub</h3>
                                    <form autocomplete="off" class="form-horizontal allcp-form" ng-submit="grubhubIntegration()">
                                        <div class="form-group floating">
                                            <input type="text" name="imap_host" id="imap_host" ng-minlength="6" placeholder="Imap Host" class="form-control" ng-model="grubhub.imap_host" required>
                                            <label>Imap Host</label>
                                        </div>
                                        <div class="form-group floating">
                                            <input type="text" name="imap_port" id="imap_port" ng-minlength="6" placeholder="Imap Port" class="form-control" ng-model="grubhub.imap_port" required>
                                            <label>Imap Port</label>
                                        </div>

                                        <div class="form-group floating">
                                            <input type="email" id="email" autocomplete="new-password" ng-minlength="6" placeholder="******" class="form-control" ng-model="grubhub.imap_username" required>
                                            <label>Mail Address</label>
                                        </div>
                                        <div class="form-group floating">
                                            <input type="password" autocomplete="new-password" id="password" ng-minlength="6" placeholder="******" class="form-control" ng-model="grubhub.imap_password" required>
                                            <label>Password</label>
                                        </div>
                                        <div class="form-group floating">
											<input type="checkbox"
												ng-model="grubhub.auto_accept_order"
												ng-checked="grubhub.auto_accept_order"
												id="auto_accept_order">
											<label for="auto_accept_order">Enable Order Confirmed</label>
										</div>

                                        <button type="submit" class="btn">Connect</button>
                                    </form>
                                </div>
                                <div class="col-md-12">
                                    <h3>Select Printer</h3>
                                    <form autocomplete="off" class="form-horizontal allcp-form" ng-submit="savePrinter()">
                                        {{printerName}}
                                        <div class="form-group floating">
                                            <select id="printerName" 
                                                placeholder="Yazıcı Adı" 
                                                class="form-control"
                                                ng-model="printerName"
                                                required>
                                                <option value="">Select Printer</option>
                                                <option ng-value="{{ item }}" ng-repeat="item in printerList">{{ item }}</option>
                                            </select>
                                            <label>Printer</label>
                                        </div>

                                        <button type="submit" class="btn">Save</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
